import React, { useState, useRef } from 'react'
import Question from './Question'
import Slider from 'react-slick';

import { VfContext } from './VfContext';

import './styles/slick.css';
import Final from './Final';

const VfSlider = ({ size, preguntas, deck }) => {

  const sliderRef = useRef();
  const [paginaActual, setPaginaActual] = useState(0);
  const [acertadas, setAcertadas] = useState(0);
  const [constestadas, setContestadas] = useState(0);

  const settings = {
    dots: false,
    arrows: true,
    draggable: true,
    swipe: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    lazyLoad: 'ondemand',
    //beforeChange: () => setActivePage(-1),
    afterChange: current => setPaginaActual(current)
  }

  const sliderStyle = {
    marginLeft: '3vw',
    marginRight: '3vw'
  }

  const handleBtnClick = (i, answer_index) => {
    //console.log(vf);
    if (answer_index === preguntas[i].correcta){
      setAcertadas(acertadas + 1);
    }
      setContestadas(constestadas + 1);
  }

  const handleNext = () => {
    sliderRef.current.slickGoTo(paginaActual + 1);
  }

  const handleResultado = () => {
    sliderRef.current.slickGoTo(preguntas.length + 1)
  }

  return (
    <div className='slider-container'>
        <VfContext.Provider value={ { size: size,
                                      cantidadPreguntas: preguntas.length,
                                      constestadas: constestadas,
                                      siguienteButton: deck.siguiente_boton,
                                      correctoTexto: deck.correcto_texto,
                                      incorrectoTexto: deck.incorrecto_texto
                                      }}>
          <Slider ref={ sliderRef } {...settings} style={ sliderStyle } >
            { preguntas.map((pregunta, index) => (
              <Question
              key={ index } 
              question={ pregunta.pregunta } 
              order={ pregunta.orden }
              vfClick={ handleBtnClick }   
              right={ pregunta.correcta }
              answers= {
                [
                  pregunta.opcion_a,
                  pregunta.opcion_b,
                  pregunta.opcion_c
                ]
              }
              ilustraR={ pregunta.ilustra_derecha }
              ilustraL={ pregunta.ilustra_izquierda }
              index={ index } 
              next={ handleNext }
              />
            )) }
            { constestadas >= preguntas.length ? <Final 
              acertadas={acertadas} 
              total={preguntas.length} 
              volverJugarBoton={ deck.volver_jugar_boton } 
              deTexto={ deck.de_texto } 
              messages={ [
                deck.mensaje_menos_50, 
                deck.mensaje_mas_50, 
                deck.mensaje_100
                ] } /> : '' }
          </Slider>
        </VfContext.Provider>
        { constestadas === preguntas.length ? <button className='resultado-btn' onClick={ handleResultado }>{ deck.resultado_texto }</button> : '' }
    </div>
  )
}

export default VfSlider